// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__3c-Aj","careers":"styles_careers__2FzxR","hours":"styles_hours__2ibv7","salary":"styles_salary__3zUZl"};